import { Title2, __css, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';

const useStyles = __css({"root":{"sshi5w":"f1qcbe8p","B7ck84d":"f1ewtqcl","mc9l5x":"f22iagw","Bt984gj":"f122n59","Brf1p80":"f4d9j23","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fg89v1a","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fjshy37","De3pzq":"f1dmdbja","sj55zd":"f19n0e5"},"card":{"B2u0y6b":"f1xuog5c","a9b677":"fly5x3f","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Bt984gj":"f6jr5hl","Belr9w4":"f1noh358","Dbcxam":0,"rjzwhg":0,"Bblux5w":"fg89v1a","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"fnsi1rm","De3pzq":"fxugw4r","Beyfa6y":0,"Bbmb7ep":0,"Btl43ni":0,"B7oj6ja":0,"Dimara":"f1o0qvyv","E5pizo":"fz58gqq"},"body":{"a9b677":"fly5x3f","Be2twd7":"fkhj508","Bg96gwp":"f1i3iumi","mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1noh358","Gt91qn":0,"Bxi5vpw":0,"Bwc6af6":"f1pws37"},"icon":{"mc9l5x":"f22iagw","sj55zd":"f16muhyy"},"actions":{"mc9l5x":"f22iagw","Eh141a":"fni485r","i8kkvl":"fsnqrgy","Belr9w4":"f1wn3y0l"}});

export interface FullPageStateProps {
  title: string;
  icon?: ReactNode;
  /** `alert` for problems, `status` for neutral information. */
  role?: 'alert' | 'status';
  actions?: ReactNode;
  children?: ReactNode;
}

/** A plain-language full-page message: a title, a short explanation and what to do next. */
export function FullPageState({
  title,
  icon,
  role = 'status',
  actions,
  children,
}: FullPageStateProps) {
  const styles = useStyles();
  return (
    <main className={styles.root}>
      <div className={styles.card} role={role}>
        {icon ? (
          <span className={styles.icon} aria-hidden="true">
            {icon}
          </span>
        ) : null}
        <Title2 as="h1">{title}</Title2>
        {children ? <div className={styles.body}>{children}</div> : null}
        {actions ? <div className={styles.actions}>{actions}</div> : null}
      </div>
    </main>
  );
}


import "/opt/batiflow/app/apps/backoffice/src/shared/components/full-page-state.griffel.css";